'use client'
import { HotelGeoCode } from '@/src/types/hotels/details'
import { useTranslations } from 'next-intl'
import MapSection from './mapSection'

export interface MapSectionContainerProps {
    geo: HotelGeoCode
    hotelName: string
    address: string
}

// Logic layer: validates the geo, derives the maps deep-link URL. Renders a Leaflet
// single-marker map, matching the RN ViewOnMapTab (Leaflet-in-WebView).
const MapSectionContainer = ({ geo, hotelName, address }: MapSectionContainerProps) => {
    const t = useTranslations('hotels')
    const lat = Number(geo?.latitude)
    const lon = Number(geo?.longitude)
    const hasGeo = Number.isFinite(lat) && Number.isFinite(lon) && (lat !== 0 || lon !== 0)

    if (!hasGeo) return null

    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`

    return (
        <MapSection
            lat={lat}
            lng={lon}
            mapsUrl={mapsUrl}
            hotelName={hotelName}
            address={address}
            openMapsLabel={t('tapToOpenMaps')}
        />
    )
}

export { MapSectionContainer }
export default MapSectionContainer
